import type { OSADShipments } from "../../types/operations/osad.type";

export const osadDefaultValue: OSADShipments = {
  summary: {
    areaName: "",
    bills: 0,
    pallets: 0,
    pieces: 0,
    handlingUnits: 0,
    weight: 0,
    billsByTags: [],
  },
  shipments: [],
};
